
{
  "familyId": "GET-NEGATIEF-MIN",
  "questions": [
    {
      "id": "GET-NEGATIEF-MIN-001",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 3 − 8?",
      "options": [
        "−5",
        "5",
        "−11",
        "11"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_min_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Strategie: als je meer aftrekt dan je hebt, wordt het negatief. Stap 1: 3 − 8. Stap 2: Je hebt 3, maar trekt 8 af → 5 tekort. Stap 3: Antwoord: −5.",
        "distractorExplanations": {
          "0": "Goed! 3 − 8 = −5. Je komt 5 onder nul.",
          "1": "Veelgemaakte fout: het verschil zonder teken. |3 − 8| = 5, maar 3 − 8 = −5 (negatief).",
          "2": "Veelgemaakte fout: optellen. 3 + 8 = 11, maar met minteken: −11. De vraag is 3 − 8 = −5.",
          "3": "Veelgemaakte fout: de absolute waarden optellen. 3 + 8 = 11, maar 3 − 8 = −5."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-002",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is −4 − 6?",
      "options": [
        "−10",
        "−2",
        "2",
        "10"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_min_positief",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: aftrekken van een negatief getal → verder naar links. Stap 1: Begin bij −4. Stap 2: Trek 6 af → ga 6 stappen naar links. Stap 3: −4 − 6 = −10.",
        "distractorExplanations": {
          "0": "Goed! −4 − 6 = −10. Je gaat verder naar links op de getallenlijn.",
          "1": "Veelgemaakte fout: 6 − 4 = 2, dan minteken: −2. Maar −4 − 6 = −(4 + 6) = −10.",
          "2": "Veelgemaakte fout: het minteken vergeten. −4 − 6 = −10, niet +2.",
          "3": "Veelgemaakte fout: de absolute waarden optellen zonder minteken. 4 + 6 = 10, maar het antwoord is −10."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-003",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is −2 − (−7)?",
      "options": [
        "5",
        "−9",
        "−5",
        "9"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_min_negatief",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Strategie: min min = plus. Stap 1: −2 − (−7) = −2 + 7. Stap 2: −2 + 7 = 5. Onthoud: twee mintekens na elkaar worden een plus.",
        "distractorExplanations": {
          "0": "Goed! −2 − (−7) = −2 + 7 = 5. Min min = plus!",
          "1": "Veelgemaakte fout: de absolute waarden optellen met minteken. −2 − 7 = −9, maar het is −2 − (−7) = −2 + 7 = 5.",
          "2": "Veelgemaakte fout: het teken omdraaien. −2 + 7 = 5 (positief), niet −5.",
          "3": "Veelgemaakte fout: 2 + 7 = 9. Het antwoord is −2 + 7 = 5, niet 2 + 7 = 9."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-MIN-004",
      "familyId": "GET-NEGATIEF-MIN",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_aftrekken",
      "questionType": "multiple_choice",
      "question": "De temperatuur is −3°C. 's Nachts daalt het 9 graden. Wat is de temperatuur 's nachts?",
      "options": [
        "−12°C",
        "−6°C",
        "6°C",
        "12°C"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_min_context",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: trek de daling af. Stap 1: −3 − 9 = −12. Stap 2: Begin bij −3, ga 9 stappen naar links. Stap 3: −3 − 9 = −12°C.",
        "distractorExplanations": {
          "0": "Goed! −3 − 9 = −12°C.",
          "1": "Veelgemaakte fout: 9 − 3 = 6, dan minteken: −6. Maar −3 − 9 = −(3 + 9) = −12.",
          "2": "Veelgemaakte fout: het minteken vergeten. −3 − 9 = −12, niet +6.",
          "3": "Veelgemaakte fout: optellen. −3 + 9 = 6, maar de temperatuur daalt (aftrekken)."
        }
      }
    }
  ]
}
